<template>
  <div id="receipt-main">
    <div class="sheet">
      <div>日本語対応</div>
      <div>japanese ok</div>
    </div>
  </div>
</template>

<script>
</script>

<style lang="scss" scoped>
  #receipt-main {
    position: absolute;
    top: 0;
    left: 0;
    width: 210mm;
    height: 296mm;
    margin: 0mm;
    background-color: white;
    .sheet {
      margin: 19mm 18mm;
    }
  }
</style>
